import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import DeleteCustomFieldDefinitionMutation from '../../../../../mutations/ticketing/admin/useDeleteCustomFieldDefinitionMutation';

export function useDeleteCustomFieldDefinition() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function remove(id: string): Promise<void> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				DeleteCustomFieldDefinitionMutation,
				{id},
				() => {
					setLoading(false);
					resolve();
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {remove, loading, error, setError};
}
